import { render, staticRenderFns } from "./HeaderPricing.vue?vue&type=template&id=2047a0e7&scoped=true&"
import script from "./HeaderPricing.vue?vue&type=script&lang=js&"
export * from "./HeaderPricing.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPricing.vue?vue&type=style&index=0&id=2047a0e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2047a0e7",
  null
  
)

export default component.exports